"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DebounceContext {
    constructor(name, timeout) {
        this.name = name;
        this.timeout = timeout;
    }
    settle(val) {
        if (this._resolve) {
            this._resolve(val);
            this._resolve = undefined;
            this._promise = undefined;
            this._timer = this._timer && clearTimeout(this._timer);
        }
    }
    async runnable() {
        this.settle(false);
        this._promise = new Promise(resolve => {
            this._resolve = resolve;
            this._timer = setTimeout(() => {
                this.settle(true);
            }, this.timeout);
        });
        return this._promise;
    }
}
exports.default = DebounceContext;
//# sourceMappingURL=DebounceContext.js.map